module.exports = __webpack_public_path__ + "img/ed_sheeran.8020c528.jpg";